// PrivateRoute.js
import React, { useContext } from 'react';
import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { AuthContext } from '../../state/context/auth.context';

const PrivateRoute = () => {
  const { state } = useContext(AuthContext);
  const location = useLocation();

  const { isConnected } = state.user || {};
    // If user is not logged in, redirect to login page
  return isConnected ? <Outlet /> : <Navigate to="/login" state={{ from: location }} replace />
;
};

export default PrivateRoute;
